import React, { useState } from "react";
import { P_Props } from "./SolutionForm.type";
import { Form, Field } from "react-final-form";
import { FormUtil, FormUIUtil, loadCallback, ImageUtil } from "../../../../../utils";
import { HtmlEditor, ImageUpload, Loading, SimpleModalHeader, CategoryCard1 } from "../../../../components";
import { Grid, TextField, InputAdornment, Switch, FormControlLabel, Dialog, Checkbox } from "@material-ui/core";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import {
  Event as EventIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  CheckBox as CheckBoxIcon,
  InfoOutlined as InfoOutlinedIcon,
} from "@material-ui/icons";
import { FORM_MODE, SolutionOutputModel } from "../../../../../models";
import { SolutionService } from "../../../../../services";

const SolutionFormPresenter: React.FC<P_Props> = (props) => {
  let submit: any;
  const [visibleTextEditor, setVisibleTextEditor] = useState<boolean>(false);

  const bindingSolutionDataToForm = (data: SolutionOutputModel[]) => {
    const transfomedData = data.reduce((result, item) => {
      return {
        ...result,
        ...item,
        [`title${item.languageId}`]: item.title,
        [`description${item.languageId}`]: item.description,
        [`shortDescription${item.languageId}`]: item.shortDescription,
      };
    }, {});
    return transfomedData;
  };

  return (
    <>
      <div className="solution-form">
        <SimpleModalHeader
          title={props.mode === FORM_MODE.CREATE ? "New Page" : "Edit Page"}
          onClose={() => {
            props.onCancel();
          }}
        />
        <div className="solution-form__divide">
          <div className="solution-form__language">
            <h1>Language</h1>
            {props.languageData.map((lang) => {
              return (
                <CategoryCard1
                  key={lang.id}
                  name={lang.name}
                  picture={lang.image || undefined}
                  buildPictureSrc={ImageUtil.buildLanguageImgSrc}
                  onClick={() => {
                    props.onChangeLanguage(lang.id);
                  }}
                  selected={props.activeLanguageId === lang.id}
                  isAvatar={true}
                />
              );
            })}
          </div>

          <div className="solution-form__box">
            {props.loading && <Loading />}
            {!props.loading && (
              <Form
                initialValues={props.initData?.length ? bindingSolutionDataToForm(props.initData) : {}}
                initialValuesEqual={() => true}
                onSubmit={async (values, form) => {
                  props.onSubmit(values);
                }}
                render={({ handleSubmit, form, pristine }) => {
                  submit = handleSubmit;

                  return (
                    <form onSubmit={handleSubmit}>
                      {props.languageData.map((lang) => {
                        return (
                          <div style={{ display: props.activeLanguageId === lang.id ? "flex" : "none" }} key={lang.id}>
                            <Field
                              name={`title${lang.id}`}
                              validate={
                                lang.isPrimary ? FormUtil.Rule.required("Xin nhập tiêu đề bài viết") : undefined
                              }
                              subscription={{ touched: true, error: true, value: true }}
                            >
                              {({ input, meta, ...rest }) => {
                                return FormUIUtil.renderFormItem(
                                  "Title",
                                  <TextField
                                    {...input}
                                    {...rest}
                                    fullWidth
                                    placeholder="Add title"
                                    className="form-text-field"
                                    inputProps={{ className: "input" }}
                                    variant="outlined"
                                    onChange={(e) => input.onChange(e.target.value)}
                                    helperText={meta.touched ? meta.error : ""}
                                    error={meta.error && meta.touched}
                                  />
                                );
                              }}
                            </Field>
                          </div>
                        );
                      })}

                      <Grid item xs={12}>
                        {FormUIUtil.renderFormItem(
                          "Banner Image",
                          <>
                            <ImageUpload
                              className="solution-form__avatar"
                              fileList={props.solutionPictures}
                              max={1}
                              onChange={props.onUploadBanner}
                              onDelete={props.onRemoveBanner}
                              config={{ uploadModal: true }}
                            />
                            <p className="solution-form__avatar--note">The image size should be smaller than 2MB</p>
                          </>
                        )}
                      </Grid>

                      <Grid container spacing={6} justify="space-between">
                        <Grid item xs={12} md={6}>
                          {FormUIUtil.renderFormItem(
                            "Status",
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={props.solutionStatus.status}
                                  onChange={(e) => {
                                    props.onChangeSolutionStatus(e.target.checked);
                                  }}
                                  className="app-switch-box"
                                />
                              }
                              label={
                                <div className="form-label" style={{ marginBottom: 0 }}>
                                  Publish
                                </div>
                              }
                            />
                          )}
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <div className="solution-form__right__publish">
                            <div className="solution-form__right__publish__allow">
                              <Checkbox
                                className="app-check-box"
                                checked={props.solutionStatus.timePublication !== null}
                                onChange={(e) => {
                                  const isChecked = e.target.checked;
                                  props.onChangeShowPublishTime(isChecked);

                                  if (isChecked) {
                                    props.onChangeTimePublication(new Date().toISOString());
                                  } else {
                                    props.onChangeTimePublication(null);
                                  }
                                }}
                                icon={<CheckBoxOutlineBlankIcon style={{ fontSize: "2.2rem" }} />}
                                checkedIcon={<CheckBoxIcon style={{ fontSize: "2.2rem" }} />}
                              />
                              <div className="form-label" style={{ margin: "0 1rem" }}>
                                Publish Date <InfoOutlinedIcon style={{ marginLeft: "0.5rem" }} />
                              </div>
                            </div>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DateTimePicker
                                ampm={false}
                                inputVariant="outlined"
                                value={props.solutionStatus.timePublication}
                                onChange={(value) => {
                                  if (value) {
                                    props.onChangeTimePublication(value.toISOString());
                                  }
                                }}
                                format="dd/MM/yyyy hh:mm a"
                                className="form-text-field"
                                fullWidth
                                inputProps={{ className: "input" }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <EventIcon style={{ fontSize: "2.2rem" }} />
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </MuiPickersUtilsProvider>
                          </div>
                        </Grid>
                      </Grid>
                      <Grid item xs={12}>
                        {props.languageData.map((lang) => {
                          return (
                            <div
                              key={lang.id}
                              style={{
                                display: props.activeLanguageId === lang.id ? "flex" : "none",
                              }}
                            >
                              <Field
                                name={`shortDescription${lang.id}`}
                                validate={
                                  lang.isPrimary ? FormUtil.Rule.required("Please input description") : undefined
                                }
                              >
                                {({ input, meta, ...rest }) => {
                                  return FormUIUtil.renderFormItem(
                                    `Description`,
                                    <TextField
                                      {...input}
                                      {...rest}
                                      fullWidth
                                      placeholder="Input description"
                                      className="form-textarea-field"
                                      inputProps={{ className: "input" }}
                                      variant="outlined"
                                      onChange={(e) => input.onChange(e.target.value)}
                                      helperText={meta.touched ? meta.error : ""}
                                      error={meta.error && meta.touched}
                                    />
                                  );
                                }}
                              </Field>
                            </div>
                          );
                        })}
                      </Grid>

                      <div
                        onClick={() => {
                          setVisibleTextEditor(true);
                        }}
                        style={{ color: "#6658F3", cursor: "pointer" }}
                        className="form-label"
                      >
                        Write solution content
                      </div>
                    </form>
                  );
                }}
              />
            )}
          </div>
        </div>
        <div className="solution-form__footer">
          <button
            className="btn cancel"
            onClick={(e) => {
              e.preventDefault();
              props.onCancel();
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn save"
            onClick={(e) => {
              loadCallback(submit, e);
            }}
          >
            Save
          </button>
        </div>
      </div>

      {props.languageData.map((lang) => {
        if (props.activeLanguageId !== lang.id) {
          return <div key={lang.id}></div>;
        }

        return (
          <Dialog
            key={lang.id}
            maxWidth="lg"
            fullWidth
            open={visibleTextEditor}
            onClose={() => {
              setVisibleTextEditor(false);
            }}
          >
            <HtmlEditor
              initValue={props.solutionContent[lang.id]}
              imageHandler={props.onUploadContentImgHandler}
              onSave={(val) => {
                setVisibleTextEditor(false);
                if (props.solutionContent[lang.id] !== val) {
                  props.onChangeSolutionContent(val, lang.id);
                }
              }}
              onCancel={() => setVisibleTextEditor(false)}
              onUploadImg={SolutionService.uploadImageSolutionPage} // Thiếu api
              buildImgSrc={ImageUtil.buildSolutionImgSrc}
            />
          </Dialog>
        );
      })}
    </>
  );
};

export default SolutionFormPresenter;
